import {CSSProperties} from 'react'

interface props {
  style?: CSSProperties
}

export const LoadingSpinner = (props: props) => {
  return <i className='fas fa-spinner loader' style={props.style} data-testid='loading-spinner'></i>
}
